<template>
  <div class="classifyEdit-component" :style="height">
    <div class="classifyEdit-container" ref="addBooksComponent">
      <div class="global_popup_header">
        {{ title }}<i @click="$store.commit('windowHandle')"></i>
      </div>
      <el-form
        :model="form"
        ref="ruleForm"
        :rules="rules"
        label-position="top"
        @submit.native.prevent
      >
        <div class="global_popup_body">
          <el-form-item
            :label="$t('content.books.groupName')"
            prop="name"
            class="itemName"
          >
            <el-input
              v-model="form.name"
              :placeholder="$t('placeholder.name')"
            ></el-input>
          </el-form-item>
          <div class="edit-opts">
            <p class="item">{{ $t("content.books.showDevice") }}</p>
            <el-radio-group
              v-model="form.device_show"
              class="classifyEdit-radio-group"
            >
              <el-radio :label="2">{{ $t("content.books.notShow") }}</el-radio>
              <el-radio :label="1">{{ $t("content.books.show") }}</el-radio>
            </el-radio-group>
          </div>
          <div class="edit-opts">
            <p class="item">{{ $t("content.books.pic") }}</p>
            <div class="edit-cover">
              <img v-if="imageUrl" :src="imageUrl" alt="" />
              <img v-else src="@/assets/img/cmb_book_cover.png" alt="" />
              <div class="edit-upload">
                <el-upload
                  ref="uploadCover"
                  action=""
                  class="edit-upload-btn"
                  :show-file-list="false"
                  :on-change="coverPreview"
                  :http-request="httpRequest"
                >
                  <h4>{{ $t("commonMsg.replace") }}</h4>
                </el-upload>
              </div>
            </div>
          </div>
          <div class="edit-opts">
            <p class="item">{{ $t("content.books.release") }}</p>
            <el-select
              v-model="channelId"
              :placeholder="$t('placeholder.select')"
              value-key="value"
            >
              <el-option
                v-for="item in getBooks"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </div>
        </div>
        <!-- <div class="edit-opts">
          <p class="item items">{{ $t("content.books.relate") }}</p>
          <el-select
            v-model="orgId"
            :placeholder="$t('placeholder.select')"
            value-key="value"
          >
            <el-option
              v-for="item in total"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </div> -->
      </el-form>
      <div class="global_popup_footer">
        <button @click="submitForm('ruleForm')">
          {{ $t("commonMsg.confirm") }}
        </button>
      </div>
    </div>
  </div>
</template>
<script>
import { uploadAliyun } from "@/utils/aliyun";

export default {
  props: {
    title: String,
    bookInfo: Object,
    channel: Object
  },
  computed: {
    rules() {
      const rules = {
        name: [
          { required: true, message: this.$t("verify.name"), trigger: "blur" }
        ]
      };
      return rules;
    }
  },
  data() {
    return {
      height: "",
      form: {
        name: "", //书单名字,
        device_show: 2
      },
      lang: "", //语言
      imageUrl: "",
      orgId: "",
      channelId: "",
      total: [],
      getBooks: []
    };
  },
  methods: {
    submitForm(formName) {
      this.$refs.ruleForm.validate(async valid => {
        if (!this.channelId) {
          this.elMsg(this.$t("alertMsg.releaseChannel"), "error");
          return;
        }
        let formDate = {
          name: this.form.name,
          channelId: this.channelId,
          //   orgIds: [this.orgId],
          device_show: this.form.device_show,
          lang: ""
        };
        if (this.$refs.uploadCover.uploadFiles.length) {
          formDate.cover = await uploadAliyun(
            this.$refs.uploadCover.uploadFiles
          );
        }
        this.title !== this.$t("alertMsg.addGroup") && this.bookInfo
          ? this.$emit("editBookListEvn", formDate)
          : this.$emit("createBookListEvn", formDate);
        this.$store.commit("windowHandle");
      });
    },
    coverPreview(file) {
      let coverUrl = URL.createObjectURL(file.raw);
      this.imageUrl = coverUrl;
    },
    //        获取机构列表
    getList() {
      //   this.$http.getOrgList(this.params).then(res => {
      //     this.total = res.data.rows;
      //   });
      this.$http.getBookChannels(this.params).then(res => {
        this.getBooks = res.data.rows;
      });
    },
    httpRequest() {}
  },
  mounted() {
    if (
      this.title !== this.$t("alertMsg.addGroup") &&
      Object.keys(this.bookInfo).length
    ) {
      this.form = Object.assign(this.form, this.bookInfo);
      //   this.orgId = this.form.orgs.length ? this.form.orgs[0].id : "";
      this.channelId = this.form.parent_id;
      this.imageUrl = this.form.cover ? this.form.cover : "";
    } else {
      this.channelId = this.channel.id;
    }
    this.height = `height: ${this.$refs.addBooksComponent.clientHeight}px`;
    this.getList();
  }
};
</script>

<style lang="scss">
.classifyEdit-component {
  @include globalPopup(450px, 380px);
  .classifyEdit-container {
    flex: 1;
    background: #fff;
    border-radius: 4px;
    .edit-opts {
      display: flex;
      margin-bottom: 20px;
      > .el-input {
        flex: 1;
      }
      > .item {
        width: 100px;
      }
      > p {
        margin-right: 20px;
      }
      > p.items {
        margin-right: 0;
      }
      .edit-cover {
        position: relative;
        /*overflow: hidden;*/
        img {
          width: 120px;
          height: 166px;
        }
        .edit-upload {
          width: 100%;
          height: 100%;
          position: absolute;
          top: 0;
          left: 0;
          transition: all 0.2s;
          &:hover {
            transition: all 0.2s;
            background: rgba($color: #000000, $alpha: 0.5);
            .edit-upload-btn {
              display: block;
            }
          }
          .edit-upload-btn {
            display: none;
            cursor: pointer;
            color: #fff;
            font-weight: bold;
            position: absolute;
            left: 50%;
            top: 50%;
            transform: translate(-50%, -50%);
          }
        }
      }
    }
  }
}

.itemIcom:before {
  content: "*";
  color: #f56c6c;
  margin-right: 4px;
}

.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
}
</style>
